import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteRole = {
  name: "deleteRole" as const,
  input: z.object({ roleId: zExt.objectId() }),
  output: z.null(),
};
